import * as moment from "moment-timezone";

import { t } from "./i18n";

const timezoneNames = {
    "Africa/Abidjan": "TimezoneName_Africa_Abidjan",
    "Africa/Accra": "TimezoneName_Africa_Accra",
    "Africa/Addis_Ababa": "TimezoneName_Africa_Addis_Ababa",
    "Africa/Algiers": "TimezoneName_Africa_Algiers",
    "Africa/Asmara": "TimezoneName_Africa_Asmara",
    "Africa/Bamako": "TimezoneName_Africa_Bamako",
    "Africa/Bangui": "TimezoneName_Africa_Bangui",
    "Africa/Banjul": "TimezoneName_Africa_Banjul",
    "Africa/Bissau": "TimezoneName_Africa_Bissau",
    "Africa/Blantyre": "TimezoneName_Africa_Blantyre",
    "Africa/Brazzaville": "TimezoneName_Africa_Brazzaville",
    "Africa/Bujumbura": "TimezoneName_Africa_Bujumbura",
    "Africa/Cairo": "TimezoneName_Africa_Cairo",
    "Africa/Casablanca": "TimezoneName_Africa_Casablanca",
    "Africa/Ceuta": "TimezoneName_Africa_Ceuta",
    "Africa/Conakry": "TimezoneName_Africa_Conakry",
    "Africa/Dakar": "TimezoneName_Africa_Dakar",
    "Africa/Dar_es_Salaam": "TimezoneName_Africa_Dar_es_Salaam",
    "Africa/Djibouti": "TimezoneName_Africa_Djibouti",
    "Africa/Douala": "TimezoneName_Africa_Douala",
    "Africa/El_Aaiun": "TimezoneName_Africa_El_Aaiun",
    "Africa/Freetown": "TimezoneName_Africa_Freetown",
    "Africa/Gaborone": "TimezoneName_Africa_Gaborone",
    "Africa/Harare": "TimezoneName_Africa_Harare",
    "Africa/Johannesburg": "TimezoneName_Africa_Johannesburg",
    "Africa/Juba": "TimezoneName_Africa_Juba",
    "Africa/Kampala": "TimezoneName_Africa_Kampala",
    "Africa/Khartoum": "TimezoneName_Africa_Khartoum",
    "Africa/Kigali": "TimezoneName_Africa_Kigali",
    "Africa/Kinshasa": "TimezoneName_Africa_Kinshasa",
    "Africa/Lagos": "TimezoneName_Africa_Lagos",
    "Africa/Libreville": "TimezoneName_Africa_Libreville",
    "Africa/Lome": "TimezoneName_Africa_Lome",
    "Africa/Luanda": "TimezoneName_Africa_Luanda",
    "Africa/Lubumbashi": "TimezoneName_Africa_Lubumbashi",
    "Africa/Lusaka": "TimezoneName_Africa_Lusaka",
    "Africa/Malabo": "TimezoneName_Africa_Malabo",
    "Africa/Maputo": "TimezoneName_Africa_Maputo",
    "Africa/Maseru": "TimezoneName_Africa_Maseru",
    "Africa/Mbabane": "TimezoneName_Africa_Mbabane",
    "Africa/Mogadishu": "TimezoneName_Africa_Mogadishu",
    "Africa/Monrovia": "TimezoneName_Africa_Monrovia",
    "Africa/Nairobi": "TimezoneName_Africa_Nairobi",
    "Africa/Ndjamena": "TimezoneName_Africa_Ndjamena",
    "Africa/Niamey": "TimezoneName_Africa_Niamey",
    "Africa/Nouakchott": "TimezoneName_Africa_Nouakchott",
    "Africa/Ouagadougou": "TimezoneName_Africa_Ouagadougou",
    "Africa/Porto-Novo": "TimezoneName_Africa_Porto_Novo",
    "Africa/Sao_Tome": "TimezoneName_Africa_Sao_Tome",
    "Africa/Tripoli": "TimezoneName_Africa_Tripoli",
    "Africa/Tunis": "TimezoneName_Africa_Tunis",
    "Africa/Windhoek": "TimezoneName_Africa_Windhoek",
    "America/Adak": "TimezoneName_America_Adak",
    "America/Anchorage": "TimezoneName_America_Anchorage",
    "America/Anguilla": "TimezoneName_America_Anguilla",
    "America/Antigua": "TimezoneName_America_Antigua",
    "America/Araguaina": "TimezoneName_America_Araguaina",
    "America/Argentina/Buenos_Aires":
        "TimezoneName_America_Argentina_Buenos_Aires",
    "America/Argentina/Catamarca": "TimezoneName_America_Argentina_Catamarca",
    "America/Argentina/Cordoba": "TimezoneName_America_Argentina_Cordoba",
    "America/Argentina/Jujuy": "TimezoneName_America_Argentina_Jujuy",
    "America/Argentina/La_Rioja": "TimezoneName_America_Argentina_La_Rioja",
    "America/Argentina/Mendoza": "TimezoneName_America_Argentina_Mendoza",
    "America/Argentina/Rio_Gallegos":
        "TimezoneName_America_Argentina_Rio_Gallegos",
    "America/Argentina/Salta": "TimezoneName_America_Argentina_Salta",
    "America/Argentina/San_Juan": "TimezoneName_America_Argentina_San_Juan",
    "America/Argentina/San_Luis": "TimezoneName_America_Argentina_San_Luis",
    "America/Argentina/Tucuman": "TimezoneName_America_Argentina_Tucuman",
    "America/Argentina/Ushuaia": "TimezoneName_America_Argentina_Ushuaia",
    "America/Aruba": "TimezoneName_America_Aruba",
    "America/Asuncion": "TimezoneName_America_Asuncion",
    "America/Atikokan": "TimezoneName_America_Atikokan",
    "America/Bahia": "TimezoneName_America_Bahia",
    "America/Bahia_Banderas": "TimezoneName_America_Bahia_Banderas",
    "America/Barbados": "TimezoneName_America_Barbados",
    "America/Belem": "TimezoneName_America_Belem",
    "America/Belize": "TimezoneName_America_Belize",
    "America/Blanc-Sablon": "TimezoneName_America_Blanc_Sablon",
    "America/Boa_Vista": "TimezoneName_America_Boa_Vista",
    "America/Bogota": "TimezoneName_America_Bogota",
    "America/Boise": "TimezoneName_America_Boise",
    "America/Cambridge_Bay": "TimezoneName_America_Cambridge_Bay",
    "America/Campo_Grande": "TimezoneName_America_Campo_Grande",
    "America/Cancun": "TimezoneName_America_Cancun",
    "America/Caracas": "TimezoneName_America_Caracas",
    "America/Cayenne": "TimezoneName_America_Cayenne",
    "America/Cayman": "TimezoneName_America_Cayman",
    "America/Chicago": "TimezoneName_America_Chicago",
    "America/Chihuahua": "TimezoneName_America_Chihuahua",
    "America/Costa_Rica": "TimezoneName_America_Costa_Rica",
    "America/Creston": "TimezoneName_America_Creston",
    "America/Cuiaba": "TimezoneName_America_Cuiaba",
    "America/Curacao": "TimezoneName_America_Curacao",
    "America/Danmarkshavn": "TimezoneName_America_Danmarkshavn",
    "America/Dawson": "TimezoneName_America_Dawson",
    "America/Dawson_Creek": "TimezoneName_America_Dawson_Creek",
    "America/Denver": "TimezoneName_America_Denver",
    "America/Detroit": "TimezoneName_America_Detroit",
    "America/Dominica": "TimezoneName_America_Dominica",
    "America/Edmonton": "TimezoneName_America_Edmonton",
    "America/Eirunepe": "TimezoneName_America_Eirunepe",
    "America/El_Salvador": "TimezoneName_America_El_Salvador",
    "America/Fortaleza": "TimezoneName_America_Fortaleza",
    "America/Fort_Nelson": "TimezoneName_America_Fort_Nelson",
    "America/Glace_Bay": "TimezoneName_America_Glace_Bay",
    "America/Godthab": "TimezoneName_America_Godthab",
    "America/Goose_Bay": "TimezoneName_America_Goose_Bay",
    "America/Grand_Turk": "TimezoneName_America_Grand_Turk",
    "America/Grenada": "TimezoneName_America_Grenada",
    "America/Guadeloupe": "TimezoneName_America_Guadeloupe",
    "America/Guatemala": "TimezoneName_America_Guatemala",
    "America/Guayaquil": "TimezoneName_America_Guayaquil",
    "America/Guyana": "TimezoneName_America_Guyana",
    "America/Halifax": "TimezoneName_America_Halifax",
    "America/Havana": "TimezoneName_America_Havana",
    "America/Hermosillo": "TimezoneName_America_Hermosillo",
    "America/Indiana/Indianapolis": "TimezoneName_America_Indiana_Indianapolis",
    "America/Indiana/Knox": "TimezoneName_America_Indiana_Knox",
    "America/Indiana/Marengo": "TimezoneName_America_Indiana_Marengo",
    "America/Indiana/Petersburg": "TimezoneName_America_Indiana_Petersburg",
    "America/Indiana/Tell_City": "TimezoneName_America_Indiana_Tell_City",
    "America/Indiana/Vevay": "TimezoneName_America_Indiana_Vevay",
    "America/Indiana/Vincennes": "TimezoneName_America_Indiana_Vincennes",
    "America/Indiana/Winamac": "TimezoneName_America_Indiana_Winamac",
    "America/Inuvik": "TimezoneName_America_Inuvik",
    "America/Iqaluit": "TimezoneName_America_Iqaluit",
    "America/Jamaica": "TimezoneName_America_Jamaica",
    "America/Juneau": "TimezoneName_America_Juneau",
    "America/Kentucky/Louisville": "TimezoneName_America_Kentucky_Louisville",
    "America/Kentucky/Monticello": "TimezoneName_America_Kentucky_Monticello",
    "America/Kralendijk": "TimezoneName_America_Kralendijk",
    "America/La_Paz": "TimezoneName_America_La_Paz",
    "America/Lima": "TimezoneName_America_Lima",
    "America/Los_Angeles": "TimezoneName_America_Los_Angeles",
    "America/Lower_Princes": "TimezoneName_America_Lower_Princes",
    "America/Maceio": "TimezoneName_America_Maceio",
    "America/Managua": "TimezoneName_America_Managua",
    "America/Manaus": "TimezoneName_America_Manaus",
    "America/Marigot": "TimezoneName_America_Marigot",
    "America/Martinique": "TimezoneName_America_Martinique",
    "America/Matamoros": "TimezoneName_America_Matamoros",
    "America/Mazatlan": "TimezoneName_America_Mazatlan",
    "America/Menominee": "TimezoneName_America_Menominee",
    "America/Merida": "TimezoneName_America_Merida",
    "America/Metlakatla": "TimezoneName_America_Metlakatla",
    "America/Mexico_City": "TimezoneName_America_Mexico_City",
    "America/Miquelon": "TimezoneName_America_Miquelon",
    "America/Moncton": "TimezoneName_America_Moncton",
    "America/Monterrey": "TimezoneName_America_Monterrey",
    "America/Montevideo": "TimezoneName_America_Montevideo",
    "America/Montserrat": "TimezoneName_America_Montserrat",
    "America/Nassau": "TimezoneName_America_Nassau",
    "America/New_York": "TimezoneName_America_New_York",
    "America/Nipigon": "TimezoneName_America_Nipigon",
    "America/Nome": "TimezoneName_America_Nome",
    "America/Noronha": "TimezoneName_America_Noronha",
    "America/North_Dakota/Beulah": "TimezoneName_America_North_Dakota_Beulah",
    "America/North_Dakota/Center": "TimezoneName_America_North_Dakota_Center",
    "America/North_Dakota/New_Salem":
        "TimezoneName_America_North_Dakota_New_Salem",
    "America/Ojinaga": "TimezoneName_America_Ojinaga",
    "America/Panama": "TimezoneName_America_Panama",
    "America/Pangnirtung": "TimezoneName_America_Pangnirtung",
    "America/Paramaribo": "TimezoneName_America_Paramaribo",
    "America/Phoenix": "TimezoneName_America_Phoenix",
    "America/Port-au-Prince": "TimezoneName_America_Port_au_Prince",
    "America/Port_of_Spain": "TimezoneName_America_Port_of_Spain",
    "America/Porto_Velho": "TimezoneName_America_Porto_Velho",
    "America/Puerto_Rico": "TimezoneName_America_Puerto_Rico",
    "America/Rainy_River": "TimezoneName_America_Rainy_River",
    "America/Rankin_Inlet": "TimezoneName_America_Rankin_Inlet",
    "America/Recife": "TimezoneName_America_Recife",
    "America/Regina": "TimezoneName_America_Regina",
    "America/Resolute": "TimezoneName_America_Resolute",
    "America/Rio_Branco": "TimezoneName_America_Rio_Branco",
    "America/Santa_Isabel": "TimezoneName_America_Santa_Isabel",
    "America/Santarem": "TimezoneName_America_Santarem",
    "America/Santiago": "TimezoneName_America_Santiago",
    "America/Santo_Domingo": "TimezoneName_America_Santo_Domingo",
    "America/Sao_Paulo": "TimezoneName_America_Sao_Paulo",
    "America/Scoresbysund": "TimezoneName_America_Scoresbysund",
    "America/Sitka": "TimezoneName_America_Sitka",
    "America/St_Barthelemy": "TimezoneName_America_St_Barthelemy",
    "America/St_Johns": "TimezoneName_America_St_Johns",
    "America/St_Kitts": "TimezoneName_America_St_Kitts",
    "America/St_Lucia": "TimezoneName_America_St_Lucia",
    "America/St_Thomas": "TimezoneName_America_St_Thomas",
    "America/St_Vincent": "TimezoneName_America_St_Vincent",
    "America/Swift_Current": "TimezoneName_America_Swift_Current",
    "America/Tegucigalpa": "TimezoneName_America_Tegucigalpa",
    "America/Thule": "TimezoneName_America_Thule",
    "America/Thunder_Bay": "TimezoneName_America_Thunder_Bay",
    "America/Tijuana": "TimezoneName_America_Tijuana",
    "America/Toronto": "TimezoneName_America_Toronto",
    "America/Tortola": "TimezoneName_America_Tortola",
    "America/Vancouver": "TimezoneName_America_Vancouver",
    "America/Whitehorse": "TimezoneName_America_Whitehorse",
    "America/Winnipeg": "TimezoneName_America_Winnipeg",
    "America/Yakutat": "TimezoneName_America_Yakutat",
    "America/Yellowknife": "TimezoneName_America_Yellowknife",
    "Antarctica/Casey": "TimezoneName_Antarctica_Casey",
    "Antarctica/Davis": "TimezoneName_Antarctica_Davis",
    "Antarctica/DumontDUrville": "TimezoneName_Antarctica_DumontDUrville",
    "Antarctica/Macquarie": "TimezoneName_Antarctica_Macquarie",
    "Antarctica/Mawson": "TimezoneName_Antarctica_Mawson",
    "Antarctica/McMurdo": "TimezoneName_Antarctica_McMurdo",
    "Antarctica/Palmer": "TimezoneName_Antarctica_Palmer",
    "Antarctica/Rothera": "TimezoneName_Antarctica_Rothera",
    "Antarctica/Syowa": "TimezoneName_Antarctica_Syowa",
    "Antarctica/Troll": "TimezoneName_Antarctica_Troll",
    "Antarctica/Vostok": "TimezoneName_Antarctica_Vostok",
    "Arctic/Longyearbyen": "TimezoneName_Arctic_Longyearbyen",
    "Asia/Aden": "TimezoneName_Asia_Aden",
    "Asia/Almaty": "TimezoneName_Asia_Almaty",
    "Asia/Amman": "TimezoneName_Asia_Amman",
    "Asia/Anadyr": "TimezoneName_Asia_Anadyr",
    "Asia/Aqtau": "TimezoneName_Asia_Aqtau",
    "Asia/Aqtobe": "TimezoneName_Asia_Aqtobe",
    "Asia/Ashgabat": "TimezoneName_Asia_Ashgabat",
    "Asia/Baghdad": "TimezoneName_Asia_Baghdad",
    "Asia/Bahrain": "TimezoneName_Asia_Bahrain",
    "Asia/Baku": "TimezoneName_Asia_Baku",
    "Asia/Bangkok": "TimezoneName_Asia_Bangkok",
    "Asia/Beirut": "TimezoneName_Asia_Beirut",
    "Asia/Bishkek": "TimezoneName_Asia_Bishkek",
    "Asia/Brunei": "TimezoneName_Asia_Brunei",
    "Asia/Chita": "TimezoneName_Asia_Chita",
    "Asia/Choibalsan": "TimezoneName_Asia_Choibalsan",
    "Asia/Colombo": "TimezoneName_Asia_Colombo",
    "Asia/Damascus": "TimezoneName_Asia_Damascus",
    "Asia/Dhaka": "TimezoneName_Asia_Dhaka",
    "Asia/Dili": "TimezoneName_Asia_Dili",
    "Asia/Dubai": "TimezoneName_Asia_Dubai",
    "Asia/Dushanbe": "TimezoneName_Asia_Dushanbe",
    "Asia/Gaza": "TimezoneName_Asia_Gaza",
    "Asia/Hebron": "TimezoneName_Asia_Hebron",
    "Asia/Ho_Chi_Minh": "TimezoneName_Asia_Ho_Chi_Minh",
    "Asia/Hong_Kong": "TimezoneName_Asia_Hong_Kong",
    "Asia/Hovd": "TimezoneName_Asia_Hovd",
    "Asia/Irkutsk": "TimezoneName_Asia_Irkutsk",
    "Asia/Jakarta": "TimezoneName_Asia_Jakarta",
    "Asia/Jayapura": "TimezoneName_Asia_Jayapura",
    "Asia/Jerusalem": "TimezoneName_Asia_Jerusalem",
    "Asia/Kabul": "TimezoneName_Asia_Kabul",
    "Asia/Kamchatka": "TimezoneName_Asia_Kamchatka",
    "Asia/Karachi": "TimezoneName_Asia_Karachi",
    "Asia/Kathmandu": "TimezoneName_Asia_Kathmandu",
    "Asia/Khandyga": "TimezoneName_Asia_Khandyga",
    "Asia/Kolkata": "TimezoneName_Asia_Kolkata",
    "Asia/Krasnoyarsk": "TimezoneName_Asia_Krasnoyarsk",
    "Asia/Kuala_Lumpur": "TimezoneName_Asia_Kuala_Lumpur",
    "Asia/Kuching": "TimezoneName_Asia_Kuching",
    "Asia/Kuwait": "TimezoneName_Asia_Kuwait",
    "Asia/Macau": "TimezoneName_Asia_Macau",
    "Asia/Magadan": "TimezoneName_Asia_Magadan",
    "Asia/Makassar": "TimezoneName_Asia_Makassar",
    "Asia/Manila": "TimezoneName_Asia_Manila",
    "Asia/Muscat": "TimezoneName_Asia_Muscat",
    "Asia/Nicosia": "TimezoneName_Asia_Nicosia",
    "Asia/Novokuznetsk": "TimezoneName_Asia_Novokuznetsk",
    "Asia/Novosibirsk": "TimezoneName_Asia_Novosibirsk",
    "Asia/Omsk": "TimezoneName_Asia_Omsk",
    "Asia/Oral": "TimezoneName_Asia_Oral",
    "Asia/Phnom_Penh": "TimezoneName_Asia_Phnom_Penh",
    "Asia/Pontianak": "TimezoneName_Asia_Pontianak",
    "Asia/Pyongyang": "TimezoneName_Asia_Pyongyang",
    "Asia/Qatar": "TimezoneName_Asia_Qatar",
    "Asia/Qyzylorda": "TimezoneName_Asia_Qyzylorda",
    "Asia/Rangoon": "TimezoneName_Asia_Rangoon",
    "Asia/Riyadh": "TimezoneName_Asia_Riyadh",
    "Asia/Sakhalin": "TimezoneName_Asia_Sakhalin",
    "Asia/Samarkand": "TimezoneName_Asia_Samarkand",
    "Asia/Seoul": "TimezoneName_Asia_Seoul",
    "Asia/Shanghai": "TimezoneName_Asia_Shanghai",
    "Asia/Singapore": "TimezoneName_Asia_Singapore",
    "Asia/Srednekolymsk": "TimezoneName_Asia_Srednekolymsk",
    "Asia/Taipei": "TimezoneName_Asia_Taipei",
    "Asia/Tashkent": "TimezoneName_Asia_Tashkent",
    "Asia/Tbilisi": "TimezoneName_Asia_Tbilisi",
    "Asia/Tehran": "TimezoneName_Asia_Tehran",
    "Asia/Thimphu": "TimezoneName_Asia_Thimphu",
    "Asia/Tokyo": "TimezoneName_Asia_Tokyo",
    "Asia/Ulaanbaatar": "TimezoneName_Asia_Ulaanbaatar",
    "Asia/Urumqi": "TimezoneName_Asia_Urumqi",
    "Asia/Ust-Nera": "TimezoneName_Asia_Ust_Nera",
    "Asia/Vientiane": "TimezoneName_Asia_Vientiane",
    "Asia/Vladivostok": "TimezoneName_Asia_Vladivostok",
    "Asia/Yakutsk": "TimezoneName_Asia_Yakutsk",
    "Asia/Yekaterinburg": "TimezoneName_Asia_Yekaterinburg",
    "Asia/Yerevan": "TimezoneName_Asia_Yerevan",
    "Atlantic/Azores": "TimezoneName_Atlantic_Azores",
    "Atlantic/Bermuda": "TimezoneName_Atlantic_Bermuda",
    "Atlantic/Canary": "TimezoneName_Atlantic_Canary",
    "Atlantic/Cape_Verde": "TimezoneName_Atlantic_Cape_Verde",
    "Atlantic/Faroe": "TimezoneName_Atlantic_Faroe",
    "Atlantic/Madeira": "TimezoneName_Atlantic_Madeira",
    "Atlantic/Reykjavik": "TimezoneName_Atlantic_Reykjavik",
    "Atlantic/South_Georgia": "TimezoneName_Atlantic_South_Georgia",
    "Atlantic/Stanley": "TimezoneName_Atlantic_Stanley",
    "Atlantic/St_Helena": "TimezoneName_Atlantic_St_Helena",
    "Australia/Adelaide": "TimezoneName_Australia_Adelaide",
    "Australia/Brisbane": "TimezoneName_Australia_Brisbane",
    "Australia/Broken_Hill": "TimezoneName_Australia_Broken_Hill",
    "Australia/Currie": "TimezoneName_Australia_Currie",
    "Australia/Darwin": "TimezoneName_Australia_Darwin",
    "Australia/Eucla": "TimezoneName_Australia_Eucla",
    "Australia/Hobart": "TimezoneName_Australia_Hobart",
    "Australia/Lindeman": "TimezoneName_Australia_Lindeman",
    "Australia/Lord_Howe": "TimezoneName_Australia_Lord_Howe",
    "Australia/Melbourne": "TimezoneName_Australia_Melbourne",
    "Australia/Perth": "TimezoneName_Australia_Perth",
    "Australia/Sydney": "TimezoneName_Australia_Sydney",
    "Europe/Amsterdam": "TimezoneName_Europe_Amsterdam",
    "Europe/Andorra": "TimezoneName_Europe_Andorra",
    "Europe/Athens": "TimezoneName_Europe_Athens",
    "Europe/Belgrade": "TimezoneName_Europe_Belgrade",
    "Europe/Berlin": "TimezoneName_Europe_Berlin",
    "Europe/Bratislava": "TimezoneName_Europe_Bratislava",
    "Europe/Brussels": "TimezoneName_Europe_Brussels",
    "Europe/Bucharest": "TimezoneName_Europe_Bucharest",
    "Europe/Budapest": "TimezoneName_Europe_Budapest",
    "Europe/Busingen": "TimezoneName_Europe_Busingen",
    "Europe/Chisinau": "TimezoneName_Europe_Chisinau",
    "Europe/Copenhagen": "TimezoneName_Europe_Copenhagen",
    "Europe/Dublin": "TimezoneName_Europe_Dublin",
    "Europe/Gibraltar": "TimezoneName_Europe_Gibraltar",
    "Europe/Guernsey": "TimezoneName_Europe_Guernsey",
    "Europe/Helsinki": "TimezoneName_Europe_Helsinki",
    "Europe/Isle_of_Man": "TimezoneName_Europe_Isle_of_Man",
    "Europe/Istanbul": "TimezoneName_Europe_Istanbul",
    "Europe/Jersey": "TimezoneName_Europe_Jersey",
    "Europe/Kaliningrad": "TimezoneName_Europe_Kaliningrad",
    "Europe/Kiev": "TimezoneName_Europe_Kiev",
    "Europe/Lisbon": "TimezoneName_Europe_Lisbon",
    "Europe/Ljubljana": "TimezoneName_Europe_Ljubljana",
    "Europe/London": "TimezoneName_Europe_London",
    "Europe/Luxembourg": "TimezoneName_Europe_Luxembourg",
    "Europe/Madrid": "TimezoneName_Europe_Madrid",
    "Europe/Malta": "TimezoneName_Europe_Malta",
    "Europe/Mariehamn": "TimezoneName_Europe_Mariehamn",
    "Europe/Minsk": "TimezoneName_Europe_Minsk",
    "Europe/Monaco": "TimezoneName_Europe_Monaco",
    "Europe/Moscow": "TimezoneName_Europe_Moscow",
    "Europe/Oslo": "TimezoneName_Europe_Oslo",
    "Europe/Paris": "TimezoneName_Europe_Paris",
    "Europe/Podgorica": "TimezoneName_Europe_Podgorica",
    "Europe/Prague": "TimezoneName_Europe_Prague",
    "Europe/Riga": "TimezoneName_Europe_Riga",
    "Europe/Rome": "TimezoneName_Europe_Rome",
    "Europe/Samara": "TimezoneName_Europe_Samara",
    "Europe/San_Marino": "TimezoneName_Europe_San_Marino",
    "Europe/Sarajevo": "TimezoneName_Europe_Sarajevo",
    "Europe/Simferopol": "TimezoneName_Europe_Simferopol",
    "Europe/Skopje": "TimezoneName_Europe_Skopje",
    "Europe/Sofia": "TimezoneName_Europe_Sofia",
    "Europe/Stockholm": "TimezoneName_Europe_Stockholm",
    "Europe/Tallinn": "TimezoneName_Europe_Tallinn",
    "Europe/Tirane": "TimezoneName_Europe_Tirane",
    "Europe/Uzhgorod": "TimezoneName_Europe_Uzhgorod",
    "Europe/Vaduz": "TimezoneName_Europe_Vaduz",
    "Europe/Vatican": "TimezoneName_Europe_Vatican",
    "Europe/Vienna": "TimezoneName_Europe_Vienna",
    "Europe/Vilnius": "TimezoneName_Europe_Vilnius",
    "Europe/Volgograd": "TimezoneName_Europe_Volgograd",
    "Europe/Warsaw": "TimezoneName_Europe_Warsaw",
    "Europe/Zagreb": "TimezoneName_Europe_Zagreb",
    "Europe/Zaporozhye": "TimezoneName_Europe_Zaporozhye",
    "Europe/Zurich": "TimezoneName_Europe_Zurich",
    "Indian/Antananarivo": "TimezoneName_Indian_Antananarivo",
    "Indian/Chagos": "TimezoneName_Indian_Chagos",
    "Indian/Christmas": "TimezoneName_Indian_Christmas",
    "Indian/Cocos": "TimezoneName_Indian_Cocos",
    "Indian/Comoro": "TimezoneName_Indian_Comoro",
    "Indian/Kerguelen": "TimezoneName_Indian_Kerguelen",
    "Indian/Mahe": "TimezoneName_Indian_Mahe",
    "Indian/Maldives": "TimezoneName_Indian_Maldives",
    "Indian/Mauritius": "TimezoneName_Indian_Mauritius",
    "Indian/Mayotte": "TimezoneName_Indian_Mayotte",
    "Indian/Reunion": "TimezoneName_Indian_Reunion",
    "Pacific/Apia": "TimezoneName_Pacific_Apia",
    "Pacific/Auckland": "TimezoneName_Pacific_Auckland",
    "Pacific/Bougainville": "TimezoneName_Pacific_Bougainville",
    "Pacific/Chatham": "TimezoneName_Pacific_Chatham",
    "Pacific/Chuuk": "TimezoneName_Pacific_Chuuk",
    "Pacific/Easter": "TimezoneName_Pacific_Easter",
    "Pacific/Efate": "TimezoneName_Pacific_Efate",
    "Pacific/Enderbury": "TimezoneName_Pacific_Enderbury",
    "Pacific/Fakaofo": "TimezoneName_Pacific_Fakaofo",
    "Pacific/Fiji": "TimezoneName_Pacific_Fiji",
    "Pacific/Funafuti": "TimezoneName_Pacific_Funafuti",
    "Pacific/Galapagos": "TimezoneName_Pacific_Galapagos",
    "Pacific/Gambier": "TimezoneName_Pacific_Gambier",
    "Pacific/Guadalcanal": "TimezoneName_Pacific_Guadalcanal",
    "Pacific/Guam": "TimezoneName_Pacific_Guam",
    "Pacific/Honolulu": "TimezoneName_Pacific_Honolulu",
    "Pacific/Johnston": "TimezoneName_Pacific_Johnston",
    "Pacific/Kiritimati": "TimezoneName_Pacific_Kiritimati",
    "Pacific/Kosrae": "TimezoneName_Pacific_Kosrae",
    "Pacific/Kwajalein": "TimezoneName_Pacific_Kwajalein",
    "Pacific/Majuro": "TimezoneName_Pacific_Majuro",
    "Pacific/Marquesas": "TimezoneName_Pacific_Marquesas",
    "Pacific/Midway": "TimezoneName_Pacific_Midway",
    "Pacific/Nauru": "TimezoneName_Pacific_Nauru",
    "Pacific/Niue": "TimezoneName_Pacific_Niue",
    "Pacific/Norfolk": "TimezoneName_Pacific_Norfolk",
    "Pacific/Noumea": "TimezoneName_Pacific_Noumea",
    "Pacific/Pago_Pago": "TimezoneName_Pacific_Pago_Pago",
    "Pacific/Palau": "TimezoneName_Pacific_Palau",
    "Pacific/Pitcairn": "TimezoneName_Pacific_Pitcairn",
    "Pacific/Pohnpei": "TimezoneName_Pacific_Pohnpei",
    "Pacific/Port_Moresby": "TimezoneName_Pacific_Port_Moresby",
    "Pacific/Rarotonga": "TimezoneName_Pacific_Rarotonga",
    "Pacific/Saipan": "TimezoneName_Pacific_Saipan",
    "Pacific/Tahiti": "TimezoneName_Pacific_Tahiti",
    "Pacific/Tarawa": "TimezoneName_Pacific_Tarawa",
    "Pacific/Tongatapu": "TimezoneName_Pacific_Tongatapu",
    "Pacific/Wake": "TimezoneName_Pacific_Wake",
    "Pacific/Wallis": "TimezoneName_Pacific_Wallis",
} as const;
type TimezoneKey = keyof typeof timezoneNames;
type TimezoneKeyArray = Array<TimezoneKey>;

function getAbbreviatedTimezoneName(timezoneName: TimezoneKey): string {
    const momentTimezone = moment.tz.zone(timezoneName);
    if (momentTimezone === null) {
        throw new Error(
            "Timezone name " + timezoneName + " not found in the moment data"
        );
    }
    let abbreviatedTZName =
        momentTimezone.abbrs[momentTimezone.abbrs.length - 1];
    if (abbreviatedTZName === null) {
        abbreviatedTZName = timezoneName;
    }
    return abbreviatedTZName;
}

const getTimezoneNames = (): TimezoneKeyArray =>
    Object.keys(timezoneNames) as TimezoneKeyArray;
const getLocalizedName = (timezoneName: TimezoneKey) =>
    t(timezoneNames[timezoneName]);

export type { TimezoneKey, TimezoneKeyArray };
export { getTimezoneNames, getAbbreviatedTimezoneName, getLocalizedName };
